import { ApiUrl, ApiUrlAdmin,ApiUrlDevelop } from "../common/Config";
import { postAdmin,post,get,getAdmin,postFormData } from "../common/Helper";

export const GetAllCoaches = async (token,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getbyadminpanel`
    return await get(url,token,isAdmin)
}
export const GetCoachDetail = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getbyid?coachId=${data}`
    return await get(url,token,isAdmin)
}
export const AddCoach = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/addCoach`
    return await post(url, data, token);
}
export const UpdateCoach = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/updateCoach`
    return await post(url, data, token);
}
export const GetBadges = async (token,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getBadges`
    return await get(url,token,isAdmin)
}
export const AddBadge = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/addBadge`
    return await post(url, data, token);
}

export const GetCoachStudents = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getcoachstudents?coachUserId=${data}`
    return await get(url,token,isAdmin)
}
export const GetCoachMeetings = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/coachmeetings?coachUserId=${data}`
    return await get(url,token,isAdmin)
}
